import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RelevantTopics = () => {
  // This data now highlights areas of expertise, not generic advice.
  const weddingElements = [
    {
      title: "Exquisite Venues",
      description: "From hidden gems to iconic estates, we match you with a breathtaking backdrop that serves as the perfect canvas for your celebration.",
      icon: "MapPin"
    },
    {
      title: "Artful Cuisine",
      description: "We collaborate with culinary artists to design a menu that delights the senses, from gourmet courses to signature craft cocktails.",
      icon: "Cake" // Using 'Cake' as a more celebratory icon
    },
    {
      title: "Immersive Florals & Decor",
      description: "Our design team transforms spaces with stunning floral arrangements and cohesive decor, creating an unforgettable, immersive atmosphere.",
      icon: "Flower"
    },
    {
      title: "Captivating Entertainment",
      description: "From elegant string quartets to high-energy live bands, we procure the perfect entertainment to set the tone and create lasting memories.",
      icon: "Music"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        
        {/* New, more inspiring section header */}
        <div className="text-center mb-16">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-foreground mb-4">
            Elements of the Perfect Day
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto">
            True luxury is found in the flawless execution of details. We specialize in elevating every component of your wedding into a work of art.
          </p>
        </div>

        {/* Grid of expertise pillars */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {weddingElements.map((element, index) => (
            <div key={index} className="bg-card p-8 rounded-lg shadow-sm hover:shadow-lg transition-shadow duration-300 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-6">
                <Icon name={element.icon} size={32} className="text-primary-foreground" />
              </div>
              <h3 className="font-heading font-bold text-xl text-foreground mb-3">
                {element.title}
              </h3>
              <p className="font-body text-muted-foreground">
                {element.description}
              </p>
            </div>
          ))}
        </div>

        {/* New Call-to-Action linking to the gallery */}
        <div className="mt-16 text-center">
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.location.href = '/gallery'}
            iconName="Image"
            iconPosition="left"
          >
            View Our Inspirations
          </Button>
        </div>

      </div>
    </section>
  );
};

export default RelevantTopics;